export default __webpack_public_path__ + "static/media/ic_faqs_b.c4ab1cdf.svg";